import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
// import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import VisibilitySensor from "react-visibility-sensor";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#ffc522",
    padding: "3rem 2rem",
    transition: "all .3s smooth",
  },
  contentWrapper: {
    display: "flex",
    marginTop: "1em",
  },
  imgWrapper: {
    flex: "2",
    alignSelf: "center",
    textAlign: "-webkit-center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  img: {
    width: "21em",
    height: "20.5em",
    margin: "auto",
    backgroundImage: "url(assets/img/profile2.png)",
    backgroundRepeat: "round",
    backgroundSize: "20em",
    borderRadius: "50%",
    "&:hover": {
      boxShadow: "0px 0px 25px 10px #ff8f01",
    },
  },
  content: {
    fontSize: "1.1rem",
    flex: "3",
    flexDirection: "column",
    display: "flex",
  },
  phoneWrapper: {
    display: "flex",
    marginBottom: "1em",
    fontWeight: "600",
    fontSize: "1em",
  },
  clickToReveal: {
    border: "1px dashed",
    padding: "5px",
    cursor: "pointer",
    marginLeft: "0.5em",
  },
  a: {
    textDecoration: "none",
    color: "#1c4c99",
    alignItems: "center",
  },
  phone: {
    marginLeft: "0.5em",
    fontSize: "1.4rem",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem !important",
    },
  },
  email: {
    marginLeft: "0.5em",
    fontSize: "1.4rem",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem !important",
    },
  },
  span: {
    marginBottom: "1em",
    textAlign: "start",
  },
}));

const AboutContainer = ({ refProp, setRefInView }) => {
  const classes = useStyles();
  const [revealPhone, setRevealPhone] = useState(false);
  const [revealEmail, setRevealEmail] = useState(false);
  return (
    <VisibilitySensor
      partialVisibility
      // minTopValue={100}
      onChange={(isVisible) => isVisible && setRefInView("about")}
    >
      {({ isVisible }) => (
        <div
          ref={refProp}
          className={classes.root}
          style={{
            opacity: `${isVisible ? "1" : "0.25"}`,
          }}
        >
          <Typography variant="h4" style={{ fontWeight: "600" }}>
            {"About Me"}
          </Typography>
          <div className={classes.contentWrapper}>
            <div className={classes.imgWrapper}>
              {/* <Avatar
                alt="Singarajan G"
                src="assets/img/profile.jpg"
                component="div"
                className={classes.avatar}
              /> */}
              
              <div className={classes.img}></div>
            </div>

            <div className={classes.content}>
              <span className={classes.span}>
                {`This is `}
                <b>Singarajan</b>
                {`. I have been in the Life Insurance Industry, `}
                <b>{`since 1988`}</b>
                {`. It gives me immense pleasure being an `}
                <b>{`Insurance Consultant & Agent`}</b>
                {` of Life Insurance Corporation of India`}.
              </span>
              <span className={classes.span}>
                {`I offer personalized financial service to all my clients after
              analyzing the customer's future financial needs and their savings
              capacity.`}
              </span>
              <span className={classes.span}>
                {`I take special care in issuing the correct policies to my prospects
              and offer my support till settling the maturity claims and other
              claims.`}
              </span>
              <span className={classes.span}>
                {`I follow up their policies and pursue whether the policies are in
              force and they get their returns at the appropriate time.`}
              </span>
              <span className={classes.span}>
                {`If you are looking for an `}
                <b>{`LIC Agent`}</b>
                {` cum `}
                <b>{`Financial Consultant`}</b>
                {` to get a professional service, kindly contact me.`}
              </span>
              <Typography className={classes.phoneWrapper} variant="subtitle1">
                {"Phone: "}
                <Typography
                  variant="button"
                  className={classes.clickToReveal}
                  style={revealPhone ? { display: "none" } : {}}
                  onClick={() => setRevealPhone(true)}
                >
                  {"CLICK-TO-REVEAL"}
                </Typography>
                <a
                  className={classes.a}
                  href="tel:9383468103"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: "1.25rem",
                    display: `${revealPhone ? "flex" : "none"}`,
                  }}
                >
                  <Typography className={classes.phone} variant="h5">
                    {"+91 9383468103"}
                  </Typography>
                </a>
              </Typography>
              <Typography className={classes.phoneWrapper} variant="subtitle1">
                {"Email: "}
                <Typography
                  variant="button"
                  className={classes.clickToReveal}
                  style={revealEmail ? { display: "none" } : {}}
                  onClick={() => setRevealEmail(true)}
                >
                  {"CLICK-TO-REVEAL"}
                </Typography>
                <a
                  className={classes.a}
                  href="mailto:gsingarajan@yahoo.com?subject=via%20Portfolio"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: "1.25rem",
                    display: `${revealEmail ? "flex" : "none"}`,
                  }}
                >
                  <Typography className={classes.email} variant="h5">
                    {"gsingarajan@yahoo.com"}
                  </Typography>
                </a>
              </Typography>
              <span className={classes.span}>
                {`With LIC of India, I provide our customized services at your
              place. `}
              </span>
              <span className={classes.span}>
                {`I take this opportunity to thank the `}
                <b>{`LIC of India`}</b>
                {` and all `}
                <b>{`my policyholders`}</b>.
              </span>
              <span className={classes.span}>{`Have a great day.`}</span>
            </div>
          </div>
        </div>
      )}
    </VisibilitySensor>
  );
};

export default AboutContainer;
